import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function auth() {
    const appUrl = import.meta.env.VITE_APP_URL;

    return {
        searchUsername,
        login,
        userData,
        logout,
        updateUserUIConfig,
        getRoles
    };

    function searchUsername(username, page = 1, limit = 20, pattern = '') {
        let url = `${appUrl}/public/search_username?username=${username}&page=${page}&limit=${limit}`;
        if (pattern) {
            url += `&pattern=${encodeURIComponent(pattern)}`;
        }
        return axiosInstance.get(url);
    }

    function login(payload) {
        return axiosInstance.post(`login_check`, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    function userData() {
        return axiosInstance.get(`user/profile`);
    }

    function logout() {
        return axiosInstance.post(`user/logout`);
    }

    function getRoles(options) {
        const defaultValues = {
            limit: 300,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`company/get-roles${params}`);
    }

    function updateUserUIConfig(payload) {
        return axiosInstance.post(`user/update_ui`, JSON.stringify(payload), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
